import React from 'react';
import styled from 'styled-components';

import InfiniteCircleDots from 'components/spinners/InfiniteCircleDots';

import flexbox from 'styles/utils/flexbox';

const Spinner = () => (
  <Container>
    <InfiniteCircleDots />
  </Container>
);

export default Spinner;

const Container = styled.div`
  ${flexbox({
    justifyContent: 'center',
  })}

  margin: 190px 0;

  div {
    margin: unset;
  }
`;
